import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Segment, Form, Button, Grid } from 'semantic-ui-react';
import { combineValidators, isRequired } from 'revalidate';
import PropTypes from 'prop-types';
import { createSession, doLoginAction } from '../AuthActions';
import TextInput from '../../../app/common/Form/TextInput';
import './style.css';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import classNames from 'classnames';
import { isBrowser, isTablet, isMobile } from 'react-device-detect';
import { isProduction } from '../../../app/common/util';

const mapState = state => ({
  auth: state.auth,
  isLoggedIn: (state.auth.isLoggedIn && state.auth.isLoggedIn.result) || false,
  loading: state.async.loading
});

const actions = {
  createSession,
  doLoginAction
};

const validate = combineValidators({
  username: isRequired({ message: 'Username is required' }),
  password: isRequired({ message: 'Password is required' })
});

class AuthForm extends Component {
  static propTypes = {
    createSession: PropTypes.func.isRequired,
    doLoginAction: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired
  };

  state = {};

  constructor(props) {
    super(props);

    if (typeof props.createSession === 'function') {
      props.createSession();
    }
  }

  onFormSubmit = values => {
    const {
      auth: { csrfRequestIdentifier },
      doLoginAction
    } = this.props;

    const loginObj = {
      ...values,
      csrfRequestIdentifier
    };

    doLoginAction(loginObj);
  };

  // shouldComponentUpdate() {
  //   return false;
  // }

  render() {
    const { auth, invalid, isLoggedIn, submitting, pristine, loading } = this.props;

    if (auth.csrfRequestIdentifier && isLoggedIn) return null;

    // If production don't show login form
    if (isProduction()) return null;

    return (
      <div
        id="authForm"
        className={classNames({
          isBrowser: isBrowser,
          isTablet: isTablet,
          isMobile: isMobile
        })}
      >
        {loading && <LoadingComponent message="Authenticating . . ." />}
        <div className="header" />
        <Segment basic>
          <Form onSubmit={this.props.handleSubmit(this.onFormSubmit)}>
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width="8">
                  <Field
                    name="username"
                    placeholder="Email Id/Mobile Number"
                    type="text"
                    component={TextInput}
                  />
                  <Field
                    name="password"
                    placeholder="Password"
                    type="password"
                    component={TextInput}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Button
                  disabled={invalid || submitting || pristine}
                  positive
                  type="submit"
                >
                  Login
                </Button>
              </Grid.Row>
            </Grid>
          </Form>
        </Segment>
      </div>
    );
  }
}

export default connect(
  mapState,
  actions
)(
  reduxForm({ form: 'authForm', enableReinitialize: true, validate })(AuthForm)
);
